import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/sgtec/gestores/pagamentos?situacao=${filtro.situacao}&status=${filtro.status}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/gestores/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(`${api}/sgtec/gestores/pagamentos/anexos/${pagamentoAnexoId}`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/gestores/pagamentos/${pagamentoId}/historico`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/gestores/pagamentos/${pagamentoId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    // Métodos para Notas Fiscais
    obterNotasFiscais(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/gestores/pagamentos/${pagamentoId}/notasfiscais`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentoNotaFiscal(pagamentoNotaFiscalId) {
        return axiosJwt
            .get(
                `${api}/sgtec/gestores/pagamentos/notasfiscais/${pagamentoNotaFiscalId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoNotaFiscal(pagamentoNotaFiscal) {
        // Separar o arquivo do resto dos dados
        const arquivo = pagamentoNotaFiscal.anexoNotaFiscal
        
        // Criar o DTO sem o arquivo
        const notaFiscalDto = {
            pagamentoId: pagamentoNotaFiscal.pagamentoId,
            tipo: pagamentoNotaFiscal.tipo,
            numeroNota: pagamentoNotaFiscal.numeroNota,
            dataEmissao: pagamentoNotaFiscal.dataEmissao,
            mesCompetencia: pagamentoNotaFiscal.mesCompetencia,
            valorNota: pagamentoNotaFiscal.valorNota,
            localPrestacao: pagamentoNotaFiscal.localPrestacao,
            servicoPorSocio: pagamentoNotaFiscal.servicoPorSocio,
            
            // Dados do Prestador
            prestadorCnpjCpf: pagamentoNotaFiscal.prestadorCnpjCpf,
            prestadorInscricaoMunicipal: pagamentoNotaFiscal.prestadorInscricaoMunicipal,
            prestadorRazaoSocial: pagamentoNotaFiscal.prestadorRazaoSocial,
            prestadorNomeFantasia: pagamentoNotaFiscal.prestadorNomeFantasia,
            prestadorOptanteSimples: pagamentoNotaFiscal.prestadorOptanteSimples,
            prestadorTelefone: pagamentoNotaFiscal.prestadorTelefone,
            prestadorEndereco: pagamentoNotaFiscal.prestadorEndereco,
            
            // Dados do Tomador
            tomadorCnpjCpf: pagamentoNotaFiscal.tomadorCnpjCpf,
            tomadorRazaoSocial: pagamentoNotaFiscal.tomadorRazaoSocial,
            tomadorEmail: pagamentoNotaFiscal.tomadorEmail,
            tomadorTelefone: pagamentoNotaFiscal.tomadorTelefone,
            tomadorEndereco: pagamentoNotaFiscal.tomadorEndereco,
            
            // Valores
            valorServico: pagamentoNotaFiscal.valorServico,
            valorDeducao: pagamentoNotaFiscal.valorDeducao,
            valorIss: pagamentoNotaFiscal.valorIss,
            valorPis: pagamentoNotaFiscal.valorPis,
            valorCofins: pagamentoNotaFiscal.valorCofins,
            valorInss: pagamentoNotaFiscal.valorInss,
            valorIr: pagamentoNotaFiscal.valorIr,
            valorCsll: pagamentoNotaFiscal.valorCsll,
            
            // Alíquotas
            aliquotaIss: pagamentoNotaFiscal.aliquotaIss,
            aliquotaPis: pagamentoNotaFiscal.aliquotaPis,
            aliquotaCofins: pagamentoNotaFiscal.aliquotaCofins,
            aliquotaInss: pagamentoNotaFiscal.aliquotaInss,
            aliquotaIr: pagamentoNotaFiscal.aliquotaIr,
            aliquotaCsll: pagamentoNotaFiscal.aliquotaCsll,
            
            // Outros campos
            codigoAtividade: pagamentoNotaFiscal.codigoAtividade,
            descricaoAtividade: pagamentoNotaFiscal.descricaoAtividade,
            cosServico: pagamentoNotaFiscal.cosServico,
            descricaoServico: pagamentoNotaFiscal.descricaoServico,
            descricaoNota: pagamentoNotaFiscal.descricaoNota
        }

        // Criar FormData apenas com o DTO e o arquivo
        const formData = new FormData()
        formData.append('notaFiscal', JSON.stringify(notaFiscalDto))
        if (arquivo) {
            formData.append('anexoNotaFiscal', arquivo)
        }

        return axiosJwt
            .post(
                `${api}/sgtec/gestores/pagamentos/${pagamentoNotaFiscal.pagamentoId}/notasfiscais`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
